import { chartCapableOfHavingInsights } from '../reusableData/chartData';

const checkInsightsCapableChart = ({ chartKey }: { chartKey: string }) => {
  const isCapable = chartCapableOfHavingInsights.some((elem) => chartKey === elem);
  return isCapable;
};
export { checkInsightsCapableChart };
